import { useEffect, useState } from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { LicenseInfo } from '@mui/x-license-pro';
import { XGridStyles } from "./Xgrid.styles";
import {
  generateColumns,
  validateRowSelected,
} from "../../../services/Local-services";
import { routeInfo, rowSelected, userCredentials } from "../../../recoilState/GlobalState";
import { useRecoilState, useRecoilValue } from "recoil";

export default function ServerPaginationGrid({
  titles,
  updateList = async () => {},
  onPageChange = () => {},
  onPageSizeChange = () => {},
  onNumberOfPagesChange = () => {},
  forceUpload = false,
  filtros = {},
}) {
  const [isLoading, setIsLoading] = useState(true);
  const { route } = useRecoilValue(routeInfo);
  const [selected, setSelected] = useRecoilState(rowSelected);
  const [rows, setRows] = useState([]);
  const [pages, setPages] = useState({});
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [upload, setUpload] = useState(false);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const credentials = useRecoilValue(userCredentials);
  
  const getList = async (newPage = 0, force = false) => {
    // Evitamos llamar al backend sin credenciales cargadas
    if (!credentials || !credentials.hooliToken) {
      return;
    }
    const cacheKey = `${newPage}-${JSON.stringify(filtros)}`;
    if (!force && pages[cacheKey]) {
      setRows(pages[cacheKey]);
      return;
    }
    
    setIsLoading(true);
    const data = await updateList(newPage, pageSize, credentials);
    const { rows: newRows, rowCount: newRowCount } = data
    newRows?.length > 0 ? setRows(newRows) : setRows([]);
    setPages(prev => ({ ...prev, [cacheKey]: newRows }));
    setRowCount(newRowCount);
    setIsLoading(false);
  };

  useEffect(() => {
    if (pageSize && !initialLoaded) {
      getList(0);
      setInitialLoaded(true);
    }
  }, [pageSize]);

  useEffect(() => {
    if (forceUpload !== upload && pageSize) {
      setUpload(forceUpload);
      getList(page, true);
    }
  }, [forceUpload]);

  useEffect(() => {
    setPages([]);
    setInitialLoaded(false);
    getList(0)
  }, [filtros]); 

  useEffect(() => {
    if(credentials.hooliToken){
      getList(0)
    }
  },[credentials])

  useEffect(() => {
    if (initialLoaded && pageSize > 0) {
      getList(page);
    }
  }, [page]);

  const columns = generateColumns(titles, route);
  const classes = XGridStyles();

  LicenseInfo.setLicenseKey("30233eb2337a94a7243a6eaf0742dec5Tz0xMjg2NDgsRT0xODA5MDAwMDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=");

  return (
    <DataGridPro
      columns={columns}
      rows={rows}
      rowCount={rowCount}
      loading={isLoading}
      pagination
      page={page}
      pageSize={pageSize}
      paginationMode="server"
      onPaginationModelChange={({ page: newPage, pageSize: newPageSize }) => {
        const pageChanged = newPage !== page;
        const sizeChanged = newPageSize !== pageSize;

        if (sizeChanged) {
          setPageSize(newPageSize);
          onPageSizeChange(newPageSize);
          setPage(0); // reiniciar paginación
          getList(0);
        } else if (pageChanged) {
          setPage(newPage);
          onPageChange(newPage);
          getList(newPage);
        }
      }}
      onStateChange={(state) => {
        const newNumberOfPages = state.pagination.pageCount + 1;
        const newSize = state?.pagination?.paginationModel?.pageSize;
        if (newSize !== pageSize) {
          setPageSize(newSize);
          onPageSizeChange(newSize);
        }
        if (newNumberOfPages !== numberOfPages) {
          setNumberOfPages(newNumberOfPages);
          onNumberOfPagesChange(newNumberOfPages);
        }
      }}
      onRowClick={(data, event) =>{
        setSelected({status: true, row: data})}
      }
      className={classes.root}
      hideFooterSelectedRowCount
      disableMultipleSelection
      rowHeight={32}
      autoPageSize
      disableColumnMenu
      localeText={{
        noRowsLabel: "Sin datos",
        columnMenuSortAsc: "Ordenar ASC",
        columnMenuSortDesc: "Ordenar DESC",
        columnMenuFilter: "Filtrar",
        columnMenuHideColumn: "Ocultar",
        columnMenuShowColumns: "Mostrar columnas",
      }}
    />
  );
}
